import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import OnboardingBottomNav from '../../components/common/OnboardingBottomNav';
import '../../styles/onboarding/Onboarding.css';

const AnniversaryDatePage = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const location = useLocation();
  const [anniversaryDate, setAnniversaryDate] = useState('');
  const [familyStatus, setFamilyStatus] = useState('');

  // Get the family status from the location state
  useEffect(() => {
    if (location.state && location.state.familyStatus) {
      setFamilyStatus(location.state.familyStatus);
    }
  }, [location.state]);

  // Handle back button
  const handleBack = () => {
    navigate(`/group/${groupId}/onboarding/profile`);
  };

  // Handle skip button
  const handleSkip = () => {
    if (familyStatus === 'married-kids') {
      // If married with kids, go to kids birthday page
      navigate(`/group/${groupId}/onboarding/kids`);
    } else {
      // Go to yartzheits page or completion based on navigation flow
      navigate(`/group/${groupId}/onboarding/yartzheits`);
    }
  };

  // Handle next button
  const handleNext = () => {
    // Save the anniversary date
    console.log('Saving anniversary date:', anniversaryDate);
    localStorage.setItem('anniversaryDate', anniversaryDate);
    
    if (familyStatus === 'married-kids') {
      // If married with kids, go to kids birthday page
      navigate(`/group/${groupId}/onboarding/kids`);
    } else {
      // Go to yartzheits page instead of identity
      navigate(`/group/${groupId}/onboarding/yartzheits`);
    }
  };

  // Handle input change
  const handleDateChange = (e) => {
    setAnniversaryDate(e.target.value);
  };

  // Check if form is valid (date is selected)
  const isFormValid = anniversaryDate !== '';

  // Progress dots renderer
  const renderProgressDots = () => {
    const totalSteps = 5; // Updated total steps including yartzheits
    const currentStep = 3;
    const dots = [];
    
    for (let i = 0; i < totalSteps; i++) {
      dots.push(
        <div 
          key={i} 
          className={`progress-dot ${i + 1 <= currentStep ? 'active' : ''}`}
        ></div>
      );
    }
    
    return dots;
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-content">
        <h1 className="anniversary-title">Don't Forget your Anniversary</h1>
        
        <p className="anniversary-subtitle">
          Wohoo! Mazel tov on being married! Don't worry—if you forget your anniversary, your shul's got your back
        </p>
        
        <div className="anniversary-form">
          <label className="form-label">Anniversary Date</label>
          <input
            type="date"
            className="form-control"
            value={anniversaryDate}
            onChange={handleDateChange}
            max={new Date().toISOString().split('T')[0]} // Set max date to today
          />
        </div>
      </div>
      
      {/* Progress dots */}
      <div className="fixed-progress-dots">
        {renderProgressDots()}
      </div>
      
      {/* Skip button */}
      <div className="skip-button-container">
        <button className="skip-button" onClick={handleSkip}>
          Skip
        </button>
      </div>
      
      {/* Use OnboardingBottomNav component for consistent navigation */}
      <OnboardingBottomNav
        onBack={handleBack}
        onNext={handleNext}
        nextDisabled={!isFormValid} 
        nextLabel="Next"
      />
    </div>
  );
};

export default AnniversaryDatePage;